import Layout from "@/components/feature/Layout";
import PageHero from "@/components/base/PageHero";
import SectionHeader from "@/components/base/SectionHeader";
import CTAPanel from "@/components/base/CTAPanel";
import RelatedContent from "@/components/feature/RelatedContent";

const serviceAreas = [
  {
    title: "Enterprise Application Support",
    description: "Mitaja has provided specialist software and enterprise application support for federal IT environments, including WebSphere and associated software platforms.",
    icon: "ri-layout-grid-line",
  },
  {
    title: "Application Integration",
    description: "Mitaja provides application integration analyst support for enterprise environments.",
    icon: "ri-layout-grid-line",
  },
  {
    title: "Platform Engineering",
    description: "Enterprise platform engineering support, including infrastructure platforms and middleware environments within complex IT systems.",
    icon: "ri-layout-grid-line",
  },
  {
    title: "WebSphere Support",
    description: "WebSphere and associated software support for enterprise application environments through federal subcontract programs.",
    icon: "ri-layout-grid-line",
  },
  {
    title: "Application Maintenance",
    description: "Ongoing application maintenance and support services for enterprise software and platform environments.",
    icon: "ri-layout-grid-line",
  },
  {
    title: "Data Development",
    description: "Mitaja has provided senior data development resources for commercial enterprise programs, supporting data pipeline and integration activities.",
    icon: "ri-layout-grid-line",
  },
  {
    title: "Python Development Resources",
    description: "Python development resources for enterprise commercial programs, supporting application and data development activities.",
    icon: "ri-layout-grid-line",
  },
  {
    title: "Integration Support",
    description: "Integration support for enterprise applications, data platforms, and middleware within complex IT environments.",
    icon: "ri-layout-grid-line",
  },
];

export default function ApplicationPlatformEngineering() {
  return (
    <Layout>
      <PageHero
        title="Application & Platform Engineering"
        subtitle="Enterprise Software & Platform Support"
        description="Enterprise application support, platform engineering, WebSphere support, application integration, and development resources."
        size="md"
      />

      <section className="section-padding bg-white">
        <div className="container-page">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
            <div className="lg:col-span-2">
              <SectionHeader
                title="Service Areas"
                centered={false}
              />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {serviceAreas.map((area) => (
                  <div key={area.title} className="card-base p-6">
                    <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                      <i className={`${area.icon} text-primary-600`}></i>
                    </div>
                    <h3 className="text-lg font-bold text-foreground-900 mb-2">
                      {area.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {area.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <div className="mt-6 bg-primary-50 rounded-lg p-6 border border-primary-100">
                <h3 className="text-sm font-bold text-primary-800 uppercase tracking-wider mb-3">
                  Technologies
                </h3>
                <div className="flex flex-wrap gap-2">
                  {["WebSphere", "Java", "C#", "ASP.NET", "Python", "Application Integration"].map((tag) => (
                    <span key={tag} className="text-xs px-2.5 py-1 rounded-full bg-white text-primary-700 font-medium border border-primary-100">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <RelatedContent
        subtitle="Related Information"
        title="Application Experience & Delivery Details"
        description="See the documented enterprise application experience behind this capability and how to engage Mitaja."
        links={[
          {
            label: "U.S. Government Application Experience",
            description: "Documented enterprise application, platform, WebSphere, and integration support within federal IT environments.",
            href: "/experience/usa-government",
            icon: "ri-layout-grid-line",
          },
          {
            label: "Capability Statement",
            description: "Review Mitaja's capability statement for procurement, teaming, and qualification review.",
            href: "/resources/capability-statement",
            icon: "ri-file-list-line",
          },
          {
            label: "Contact Mitaja",
            description: "Discuss application support, integration, or teaming requirements with our team.",
            href: "/contact",
            icon: "ri-mail-line",
          },
        ]}
      />

      <CTAPanel
        title="Need Application Support?"
        description="Mitaja provides qualified application specialists, developers, and integration resources for enterprise programs."
        secondaryAction={{ label: "View Past Performance", href: "/experience" }}
        variant="dark"
      />
    </Layout>
  );
}